export const uscisCaseNumberRegex = /(?:^[a-zA-Z]{3}\d{10}$)/
export const dolCaseNumberRegex = /(?:^(?:G|I|H|P)-\d{3}-\d{5}-\d{6})$/
export const eoirCaseNumberRegex = /^\d{8,9}$/
export const urlIncaseHistoryMessageRegex = /www\.[^\s/$.?#]+\.[^\s]+/g